<template>
  <li>
    <div class="box grid grid-responsive week_notes_lesson_note" :style="{ borderColor: event.color }">
      <div class="col-2-12 box-size">
        <h3 :style="{ color: event.color }">{{event.title}}</h3>
        <span class="bold">
              <span class="icon-clock"></span> {{$filters.timeStamp(event.start)}} - {{$filters.timeStamp(event.end)}}<br>
            </span>
      </div>
      <div class="col-10-12">
        <div class="col-1-3" v-if="checkLengthWithoutHTML(event.learning_goal)">
          <p :style="{ color: event.color }"><b>{{ $t('calendars.week_plan.learning_goal') }}</b></p>
          <div class="word-break" v-html="event.learning_goal"></div>
        </div>
        <div class="col-1-3" v-if="checkLengthWithoutHTML(event.description)">
          <p :style="{ color: event.color }"><b>{{ $t('calendars.week_plan.content') }} </b></p>
          <div class="word-break" v-html="event.description"></div>
        </div>
        <div class="col-1-3" v-if="checkLengthWithoutHTML(event.notes_for_students)">
          <p :style="{ color: event.color }"><b>{{ $t('calendars.week_plan.pupil_preparation') }}</b></p>
          <div class="word-break" v-html="event.notes_for_students"></div>
        </div>
      </div>
    </div>
  </li>
</template>

<script>
  import moment from 'moment' // eslint-disable-line no-unused-vars

  export default {
    props: ['event', 'date'],
    methods: {
      checkLengthWithoutHTML (text) {
        return text.replace(/<(?:.|\n)*?>/gm, '')
      }
    }
  }
</script>
<style scoped>
  .week_notes_lesson_note {
    font-size: 13px;
    background: #f6f7f8;
    border-left: 3px solid #e74c3c;
    border-radius: 3px;
    overflow: hidden;
    padding: 10px 20px;
    margin-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// WeekPlanLesson.vue?290d1349